import React from 'react'
import Collection from '../common/collection'

function CollectionR({ props }) {
  return (
    <Collection
      src={['https://volverse-negro-daniel.s3.amazonaws.com/images/17.+t%C3%B3rtolas+palmeras18.jpg']}
      alt="Tórtolas"
    />
  )
}


export default CollectionR
